import React from 'react';
import { Badge } from '@mui/material';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

export const ChatIconBadge = ({ unreadMessageCount }) => {
  return (
    <Badge 
      color="secondary" 
      badgeContent={unreadMessageCount} 
      invisible={unreadMessageCount === 0}
    >
      <ChatBubbleIcon />
    </Badge>
  );
};
